/**
 * @author Yaochao
 * @date 2021/12/15 14:52
 * @description
 */
import React from 'react'
import Api from "../../../util/Api";
import anquan from "../../../image/taskrank/midpage/anquan.png";
import towardsLeft from "../../../image/taskrank/midpage/towardsLeft.svg";
import towardsRight from "../../../image/taskrank/midpage/towardsRight.svg";
import copy from 'copy-to-clipboard';
import {Toast} from "antd-mobile";

class Invite extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loaded: 0,
        }
    }

    componentDidMount() {
        let data = this.props.match.params.data;
        Api.getTaskMidPageData(data, (resp) => {
            this.setState({
                qrcode: resp.respMsg.qrcode,
                midtype: resp.respMsg.midtype,
                keyword: resp.respMsg.keyword,
                subsname: resp.respMsg.subsname,
                substype: resp.respMsg.substype,
                loaded: 1
            });
            document.title = '长按二维码关注后发送邀请码，继续参与活动';
        })
    }

    handleCopy() {
        if (copy(this.state.keyword)) {
            Toast.success("复制成功，关注公众号后，发送邀请码即可为好友助力", 1)
        }
    }

    render() {
        if (this.state.loaded) {
            return (
                <div className="inviteWrapper">
                    <img className='inviteQrcode' src={this.state.qrcode}/>
                    <div className="inviteTip">
                        <img src={anquan} width={20}/>
                        此二维码已通过安全认证，可以放心扫码
                    </div>
                    <div className="inviteCon">
                        <div className="qrcodeCon">
                            <p>长按二维码识别并关注</p>
                            <img src={this.state.qrcode}/>
                        </div>
                        <div className='splitLine'>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <div className='inviteTitle'>
                            <img src={towardsRight}/>
                            <span>活动邀请码</span>
                            <img src={towardsLeft}/>
                        </div>
                        <p className='inviteCode'>{this.state.keyword}</p>
                        <p className='inviteDes'>关注公众号后，发送邀请码即可为好友助力</p>
                        <div className='copyBtn'>
                            <span onClick={this.handleCopy.bind(this)}>复制邀请码发至公众号</span>
                        </div>
                    </div>
                    <div className="footer-logo"></div>
                </div>
            )
        } else {
            return (
                <></>
            )
        }
    }
}

export default Invite